import { render, staticRenderFns } from "./averageWeightGainFromTwoDays.vue?vue&type=template&id=e04b367e&scoped=true&"
import script from "./averageWeightGainFromTwoDays.vue?vue&type=script&lang=js&"
export * from "./averageWeightGainFromTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04b367e",
  null
  
)

export default component.exports